import instance from "@/store/actions/instance";
import { Button, Drawer, message, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import WhatsappChatMessages from "./WhatsappChatMessages";
import WhatsappChatItem from "./WhatsappChatItem";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CloseOutlined,
} from "@ant-design/icons";

function WhatsappChat({
  config,
  t,
  closeDrawer,
  open,
  hasUnreadWhatsappMessages,
}) {
  const [loading, setLoading] = useState(true);
  const [chats, setChats] = useState(null);
  const [selectedChat, setSelectedChat] = useState(null);
  const isRTL = config?.direction === "rtl";

  const shouldFetchOnOpenRef = useRef(false);

  const fetchChats = async () => {
    try {
      const res = await instance.get("/facebook/chats");
      setChats(res.data);
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!open) return;
    if (
      !chats?.length ||
      (shouldFetchOnOpenRef.current && hasUnreadWhatsappMessages)
    ) {
      fetchChats();
      shouldFetchOnOpenRef.current = false;
    }
    const interval = setInterval(async () => {
      fetchChats();
    }, 1000 * 60 * 5);

    return () => clearInterval(interval);
  }, [open]);
  return (
    <Drawer
      placement={isRTL ? "left" : "right"}
      open={open}
      onClose={() => {
        closeDrawer();
        shouldFetchOnOpenRef.current = true;
      }}
      closable={false}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,

            background: "#fff",
          }}
        >
          {selectedChat ? (
            <Button
              type="text"
              icon={
                isRTL ? (
                  <ArrowRightOutlined style={{ top: 0 }} />
                ) : (
                  <ArrowLeftOutlined style={{ top: 0 }} />
                )
              }
              onClick={() => setSelectedChat(null)}
            />
          ) : (
            <Button
              type="text"
              icon={<CloseOutlined style={{ top: 0 }} />}
              onClick={closeDrawer}
            />
          )}

          <div style={{ fontWeight: 600 }}>
            {selectedChat ? selectedChat.customer_name : t("Chats")}
          </div>
        </div>
      }
      destroyOnClose
      maskClosable
      bodyStyle={{
        padding: 12,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        // height: bodyHeight,
        direction: isRTL ? "rtl" : "ltr",
        textAlign: isRTL ? "right" : "left",
        background: "#fff",
      }}
    >
      {!selectedChat ? (
        <div style={{ height: "100%", overflowY: "auto" }}>
          {loading ? (
            <div style={{ padding: 24, textAlign: "center" }}>
              <Spin />
            </div>
          ) : chats?.length ? (
            (chats || []).map((c) => (
              <WhatsappChatItem
                key={c.customer_number}
                chat={c}
                onClick={() => setSelectedChat(c)}
              />
            ))
          ) : (
            <div style={{ padding: 24, color: "#999" }}>
              {t("No chats yet")}
            </div>
          )}
        </div>
      ) : (
        <WhatsappChatMessages
          selectedChat={selectedChat}
          setChats={setChats}
          chats={chats}
        />
      )}
    </Drawer>
  );
}

const mapStateToProps = (state) => ({
  config: state.config,
  is_staff: state.auth.is_staff,
  username: state.auth.username,
  hasUnreadWhatsappMessages: state.integration.hasUnreadWhatsappMessages,
});

export default connect(mapStateToProps)(withNamespaces()(WhatsappChat));
